import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { bindActionCreators } from 'redux'
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom'
import mixpanel from '@disco/api/mixpanel'
import { updateUserSettingsUnsafe } from '@disco/state-management/actions/ExplorerActions'
import { deleteTrack } from '@disco/state-management/actions/ServerActions'
import { getTrack } from '@disco/state-management/selectors/tracks'
import { getHideInboxRemovalSetting } from '@disco/state-management/selectors/user'
import DocumentHeadTags from 'components/document-head-tags'
import InboxRemovalDialog from 'components/modals/dialogs/inbox-removal-dialog'
import type { UserSettings } from 'types/user'
import type { Track } from 'types/track'

function mapStateToProps(state, { params: { trackId } }) {
  return {
    track: getTrack(state, {
      id: trackId,
    }),
    hideRemovalWarning: getHideInboxRemovalSetting(state),
    settings: state.user.settings,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      deleteTrack,
      updateUserSettingsUnsafe,
    },
    dispatch,
  )
}

// Define connector
const connector = connect(mapStateToProps, mapDispatchToProps)

// Infer props type from Redux
type PropsFromRedux = ConnectedProps<typeof connector>

// Own props interface
interface OwnProps {
  navigate: NavigateFunction
  params: {
    trackId: string
  }
}

// Component props = Redux props + own props
type Props = PropsFromRedux & OwnProps

class TrackRemove extends React.Component<Props> {
  _onClose = () => this.props.navigate('/')
  _handleDelete = () => {
    this.props.deleteTrack({ id: this.props.track.id })
    mixpanel.sendPureEvent('Click icon', {
      'Track ID': this.props.track?.id,
      Type: 'Track',
      Icon: 'Delete',
      Context: 'Inbox',
    })
    this.props.navigate('/')
  }
  _hideWarning = () => {
    this.props.updateUserSettingsUnsafe({
      settings: {
        hide_inbox_removal_warning: !this.props.hideRemovalWarning,
      },
    })
  }

  render() {
    return (
      <div>
        <DocumentHeadTags title="Remove track from inbox | DISCO" />
        <InboxRemovalDialog
          onConfirm={this._handleDelete}
          onCancel={this._onClose}
          onHideWarningChange={this._hideWarning}
          hideWarning={this.props.hideRemovalWarning}
          type="track"
        />
      </div>
    )
  }
}

const ConnectedTrackRemove = connector(TrackRemove)

function TrackRemoveWithRouter(props: any) {
  const navigate = useNavigate()
  const params = useParams<{ trackId: string }>()
  return <ConnectedTrackRemove {...props} navigate={navigate} params={params} />
}

export default TrackRemoveWithRouter
